import React, { useEffect, useState } from 'react';
import SubjectEntry from './index'; 
import SubjectCallViewOnly from './SubjectCallViewOnly';


const SubjectEditorTabs = (props) => {
  
  
  const { enableNewSubjectView = true } = props;

  
  if (!enableNewSubjectView) {
    return <SubjectEntry {...props} />;
  }

  useEffect(() => {
    document.getElementById('root').scrollTo({ top: 0 });
  }, []);

  const [activeTab, setActiveTab] = useState('new');

  const getTabStyle = (isActive) => ({
    padding: '12px 24px',
    cursor: 'pointer',
    color: isActive ? '#2E2868' : '#6c757d',
    fontWeight: isActive ? '600' : '500',
    transition: 'all 0.2s ease-in-out',
    marginBottom: '-1px' 
  });

  return (
    <div className="d-flex flex-column h-100">
      {/* 1. Header Area with Tabs */}
      <div className="bg-white border-bottom shadow-sm px-4 pt-2">
        <div className="d-flex gap-4">
          <div 
            onClick={() => setActiveTab('new')} 
            style={getTabStyle(activeTab === 'new')}
            role="button"
          >
            Subject Call View
          </div>
          <div 
            onClick={() => setActiveTab('old')} 
            style={getTabStyle(activeTab === 'old')}
            role="button"
          >
            Legacy View
          </div>
        </div>
      </div>

      {/* 2. Content Area */}
      <div className="flex-grow-1 overflow-auto">
        {activeTab === 'new' ? (
          <SubjectCallViewOnly {...props} />
        ) : (
          <SubjectEntry {...props} />
        )}
      </div>
    </div>
  );
};

export default SubjectEditorTabs;